import { Component, Input } from '@angular/core';
import { DataLayerService } from '../services/data-layer.service';
type Leader = {
  leader_name: string;
  leader_position: string;
  leader_slug: string;
  banner_image: string;
};

@Component({
  selector: 'app-leader',
  templateUrl: './leader.component.html',
  styleUrls: ['./leader.component.css']
})
export class LeaderComponent {
  @Input('leadership_title') leadership_title!: string;
  @Input('leaders') leaders: Leader[]=[];
  slideConfig = {dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    variableWidth: true,
    responsive: [
    {
        breakpoint: 1200,
        settings: {
            slidesToShow: 2
        }
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 1
        }
    }
]};
  constructor(private ga:DataLayerService) { }
  ngOnInit(): void {}
  registerGA_AboutRbBio(){
    this.ga.rb_bio_arrow_click({
      label: '',
      pagetype: window.location.href.split("/").pop()
    })
  } 
  registerGA_AboutSbBio(){
    this.ga.sb_bio_arrow_click({
      label: '',
      pagetype: window.location.href.split("/").pop()
    })
  } 


}
